import { AuthMethod } from './parts/auth-method';
import { Localization } from '../localization/localization';
import { ChangePasswordErrorCodes } from './parts/change-password';

export class AccountView {
    public static uiGroups = {
        CHANGE_PASS: 'changepass'
    };

    private static prevOpened = $([]);

    public static hasAccountTetheredBlock() {
        return $('#play_via_h').length > 0;
    }


    public static closeAccountWindow() {
        window.app.game_popup_close();
        AccountView.hideAccountError();
    }

    public static scrollTo(selector: string) {
        const targetEl = $(selector);

        $('#popup_body_wrapper').scrollTop(targetEl.offset().top);
    }

    public static showSavedGroups() {
        this.prevOpened.show();
    }

    public static removeBodyWrapper() {
        const $am = $('#account_management');
        $('.scroll-wrapper.scrollbar-rail', $am).remove();
    }

    public static saveOpenedGroups() {
        const $am = $('#account_management');
        this.prevOpened = $am.find('[data-ui-group]:visible');
    }

    public static hideUIGroups() {
        const $am = $('#account_management');
        $am.find('[data-ui-group]').hide();
    }

    public static hideAccountLoadingState() {
        const scrollBarWrapperClass = '.scrollbar-rail';
        const $am = $('#account_management');
        $('.accountmanagement_loading').removeClass('--withoutspan')
            .hide();
        $(scrollBarWrapperClass, $am).show();
        AccountView.showSavedGroups();
    }

    public static showAccountLoadingState() {
        const scrollBarWrapperClass = '.scrollbar-rail';
        const $am = $('#account_management');
        AccountView.saveOpenedGroups();
        AccountView.hideUIGroups();
        $(scrollBarWrapperClass, $am).hide();
        $('.accountmanagement_loading').show();
    }

    public static showAccountUIGroup(groupId: string) {
        const $am = $('#account_management');
        this.prevOpened.add(groupId);
        $am.find(`[data-ui-group*="${groupId}"]`).show();
    }

    public static hideAccountError() {
        const $am = $('#account_management');
        $('#input_placeholder', $am).removeClass('error');
        $('.error_bubble', $am).fadeOut();
    }

    public static showError(errorMessage: string) {
        const $am = $('#account_management');
        $('#input_placeholder', $am).addClass('error');
        $('.error_main', $am).text(errorMessage);
        $('.error_bubble', $am).fadeIn();
    }

    public static showChangepassError(errorCode: number, customErrorMessage: string = null) {
        const errorMessage = this.getErrorMessage(errorCode, customErrorMessage);

        const blockContainer = $('#account_management #changepass');
        $('#input_placeholder', blockContainer).addClass('error');
        if (errorMessage.length > 0) {
            $('.error_main', blockContainer).text(errorMessage);
            $('.error_bubble', blockContainer).fadeIn();
        }
    }

    private static getErrorMessage(errorCode: number, errorMessage: string = null): string {
        let msg: string;
        switch (errorCode) {
            case ChangePasswordErrorCodes.PASSWORD_CONFIRMATION_FAILED:
                msg = 'errors.pass_c_fail';
                break;
            case ChangePasswordErrorCodes.VALIDATION_ERROR:
                if (errorMessage) {
                    return errorMessage;
                }
                msg = 'errors.common_error';
                break;
            default:
                msg = 'errors.common_error';
        }

        return Localization._n(msg);
    }

    public static hideLinkError() {
        $('#link-email-error').hide();
        $('#link-social-error').hide();
    }

    public static showLinkError(errorMessage: string, authMethod: AuthMethod) {
        let errorContainerSelector: string;
        if (authMethod === AuthMethod.EMAIL) {
            errorContainerSelector = '#link-email-error';
        } else {
            errorContainerSelector = '#link-social-error';
        }

        const errorContainer = $(errorContainerSelector);
        errorContainer.text(errorMessage).show();
    }

    public static showSocialSwitchAccountError(text: string): void {
        const $container = $('#account_management');
        $('#switch-by-social-error__container', $container).text(text);
        $('#switch-by-social-error__container', $container).css('display', 'block');
    }

    public static hideSocialSwitchAccountError(): void {
        const $container = $('#account_management');
        $('#switch-by-social-error__container', $container).text('');
        $('#switch-by-social-error__container', $container).css('display', 'none');
    }

    public static showDisappearingMessage(placeholderSelector: string, message: string, timeToLive: number) {
        const $messagePlaceholder = $(placeholderSelector);
        const messageShowClass = 'disappearing-message--show';

        $messagePlaceholder.text(message).addClass(messageShowClass);

        setTimeout(() => {
            $messagePlaceholder.removeClass(messageShowClass);
        }, timeToLive);
    }

    public static removeHeader() {
        const $accountManagement = $('#account_management');
        $('#auth', $accountManagement).remove();
        $('#uid', $accountManagement).remove();
    }

    public static initializeCustomScrollbars() {
        const $accountManagement = $('#account_management');
        $accountManagement.find(' #popup_body_wrapper').scrollbar();
    }

    public static hideGuestWarningIcon() {
        $('.tether_social_account.error_icon').addClass('mount-hidden');
    }

    static setUserName(userName: string) {
        $('.user_name').text(userName);
    }

    static setAccountAvatar(photo: string) {
        this.getAvatarElement().attr('src', photo);
    }

    static hideAccountAvatar() {
        this.getAvatarElement().hide();
    }

    static getAvatarElement(): JQuery<HTMLImageElement> {
        const $am = $('#account_management');
        return $am.find<HTMLImageElement>('.header_user_avatar');
    }

    static showLogoutBtnForWebGuest(): void {
        $('#account_management #web-guest-logout').show();
    }

    public static setIsBigReward(isBigReward: boolean) {
        const id = 'link-email-auth';
        const rewardName = '[name=is_big_reward]';
        const linkEmailAuthForm: HTMLFormElement = <HTMLFormElement>document.getElementById(id);
        const isBigRewardInput: HTMLInputElement = <HTMLInputElement>linkEmailAuthForm.querySelector(rewardName);
        isBigRewardInput.value = isBigReward ? '1' : '';
    }
}
